// react =>
import { Navigate } from "react-router-dom";
import { useUserStore } from "../../hooks/useUserStore";

interface PublicRouteProps {
    children: React.ReactNode;
}

const PublicRoute: React.FC<PublicRouteProps> = ({ children }) => {
    const user = useUserStore((state) => state.user);
    
    if (user) {
        return <Navigate to="/" replace />;
    }
    
    return <>{children}</>;
};

export default PublicRoute;
